import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {storeNotesData, withdrawalEndUserCash} from "helpers/repository"
import * as moment from "moment"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody, Label, Form,
} from "reactstrap"

import axios from "axios";
import {API_URL} from "../../../constants/constants";
import {createBonus} from "../../../store/Bonuses/actions";
import {showMessage} from "../../../components/Common/Toaster";
import {showErrorMessages} from "../../../helpers/helpers";
import toastr from "toastr";
const { SearchBar } = Search

const Notes = props => {
  const [data, setData] = useState([])
  const [issue, setIssue] = useState("")
  const [note, setNote] = useState("")
  const [resolution, setResolution] = useState("")
  useEffect(() => {
    call()
  }, [props.userData])

  const handleSubmit = e => {
    try {
      const obj = JSON.parse(localStorage.getItem("user"));

      e.preventDefault()
      const data = {
        note_by: obj.user.id,
        note_to: props.userData.id,
        note: note,
        issue: issue,
        resolution: resolution,
      }
      storeNotesData(data)
          .then(res => {
            showMessage("success", res.data.message)
            setIssue("");
            setNote("");
            setResolution("");
            setModal(false)
            call()
          })
          .catch(error => {

            showErrorMessages(error)
          })
    } catch (error) {
      showErrorMessages(error)
    }
  }
  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/get-note-detail/${props.userData.id}`,
    })
        .then(function (response) {
          setData(response?.data?.data?.data)
        })
        .catch(function (response) {

        })
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: data.length, // replace later with size(data),
    custom: true,
  }
  const { SearchBar } = Search

  const toggleViewModal = () => setModal1(!modal1)

  const toggle = () => {
    setModal(!modal)
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      // eslint-disable-next-line react/display-name
    },
    {
      dataField: "issue",
      text: "Issue",
      sort: true,
    },

    {
      dataField: "created_at",
      text: "Created Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "note_by.name",
      text: "Person",
      sort: true,
    },
    {
      dataField: "note",
      text: "note",
      sort: true,
    },
    {
      dataField: "resolution",
      text: "resolution",
      sort: true,
    },
  ]

  return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={data}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                            keyField="id"
                            data={data}
                            columns={columns}
                            bootstrap4
                            search
                        >
                          {toolkitProps => (
                              <React.Fragment>
                                <Row className="mb-2">
                                  <Col sm="4">
                                    <div className="search-box me-2 mb-2 d-inline-block">
                                      <div className="position-relative">
                                        <SearchBar {...toolkitProps.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col sm="8">
                                    <div className="text-sm-end">
                                      <Button
                                          type="button"
                                          color="success"
                                          className="btn-rounded  mb-2 me-2"
                                          onClick={() => {
                                            toggle()
                                          }}
                                      >
                                        <i className="mdi mdi-plus me-1" />
                                        Add New Note
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                          keyField="id"
                                          responsive
                                          bordered={false}
                                          striped={false}
                                          defaultSorted={defaultSorted}

                                          classes={
                                            "table align-middle table-nowrap table-check"
                                          }
                                          headerWrapperClasses={"table-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}

                                      />
                                    </div>
                                    <Modal isOpen={modal} toggle={toggle} centered>
                                      <ModalHeader toggle={toggle} tag="h4">
                                        {!!isEdit ? "Edit Order" : "Add new Note"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <form onSubmit={handleSubmit}>
                                          <div className="mb-3">
                                            <Label htmlFor="cashier_user_name_input" className="form-label">Issue</Label>
                                            <select className="form-control" name="issue" onChange={(e) => {
                                              setIssue(e.target.value || null);
                                            }}>
                                              <option value="">Select Issue</option>
                                              <option value="registration">Registration</option>
                                              <option value="deposit_withdrawal">Deposit/Withdrawal</option>
                                              <option value="placing_bet">Placing Bet</option>
                                              <option value="jackpot">Jackpot</option>
                                              <option value="password">Password Issue</option>
                                            </select>
                                          </div>
                                          <div className="mb-3">
                                            <Label htmlFor="cashier_user_name_input" className="form-label">Note</Label>
                                            <input type="text" placeholder="Note"  className="form-control"       onChange={(e) => {
                                              setNote(e.target.value);
                                            }}/>
                                          </div>
                                          <div className="mb-3">
                                            <Label htmlFor="cashier_user_name_input" className="form-label">Resolution</Label>
                                            <select className="form-control" name="resolution" onChange={(e) => {
                                              setResolution(e.target.value || null);
                                            }}>
                                              <option value="">Select Resolution</option>
                                              <option value="resolved">Resolved</option>
                                              <option value="escalated_network">Escalated Network</option>
                                              <option value="outage_network">Outage Network</option>
                                            </select>
                                          </div>
                                          <div className="row">

                                            {/*<Col sm={12}>*/}
                                            <Col sm={6} xs={6} md={6} lg={6} xl={6}>
                                              <Button type="submit" color="primary" className="w-100">
                                                Submit
                                              </Button>
                                            </Col>
                                            <Col sm={6} xs={6} md={6} lg={6} xl={6}>
                                              <Button
                                                  type="button"
                                                  color="secondary"
                                                  className="w-100"
                                                  onClick={() => {
                                                    toggle()
                                                  }}
                                              >
                                                Cancel
                                              </Button>
                                            </Col>
                                            {/*</Col>*/}
                                          </div>
                                        </form>
                                      </ModalBody>
                                    </Modal>
                                  </Col>
                                </Row>
                                <Row className="align-items-md-center mt-30">
                                  <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                    <PaginationListStandalone {...paginationProps} />
                                  </Col>
                                </Row>
                              </React.Fragment>
                          )}
                        </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
  )
}

export default withRouter(Notes)
